<template>
  <div class="modal">
    <div class="modal-info">
      <p>The settings for this viewer were deleted by their creator.</p>
      <a
        href="#"
        class="btn"
        @click.prevent="close"
      >Continue to default settings</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalInfo',
  methods: {
    close() {
      this.$store.dispatch('config/changeErrorLoadConfigStatus', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.modal {
  position: fixed;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  width: 100%;
  height: 100%;
  z-index: 19999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-info {
  position: relative;
  max-width: 500px;
  width: 100%;
  background-color: #fff;
  min-height: 150px;
  z-index: 2000;
  padding: 40px 30px;
  box-shadow: 0 8px 40px rgba(50,123,186,.16), 0 4px 4px rgba(50,123,186,.08);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  p {
    margin-bottom: 25px;
  }
  a {
    display: inline-block;
    background-color: #fff;
    border-radius: 4px;
    background-color: #327bba;
    color: #fff;
    margin-bottom: 10px;
    padding: 6px 20px;
    text-align: center;
    border: 1px solid #327bba;
    cursor: pointer;
    -webkit-transition: background-color .5s ease, color .5s ease;
    transition: background-color .5s ease, color .5s ease;
    text-decoration: none;
  }
}

</style>
